import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';
import Translator from 'bazinga-translator';

import CropPopup from './components/CropPopup.jsx';
import UploaderMask from './components/UploaderMask.jsx';
import UploaderBackground from './components/UploaderBackground.jsx';

export default class ClientUploader extends Component {
    static propTypes = {
        filter: PropTypes.string.isRequired,
        hash: PropTypes.string,
        path: PropTypes.string,
        uploaderType: PropTypes.string,
        id: PropTypes.number,
        cropPath: PropTypes.string,
        reference: PropTypes.string,
        mediaType: PropTypes.string,
        onUpload: PropTypes.func,
        onDelete: PropTypes.func,
        onCrop: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            activeMask: false,
            loading: false,
            hovered: false,
            fetchedCropData: false,
            cropping: false,
            cropValues: undefined,
            cropPath: props.cropPath,
            path: props.path,
            reference: props.reference,
            filter: props.filter,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            ...this.state,
            path: nextProps.path,
            reference: nextProps.reference,
        });
    }

    /**
     * Changes loading state in a state tree
     * @param value
     */
    handleLoader(value: boolean) {
        this.setState({
            ...this.state,
            loading: value,
        });
    }

    /**
     * Changes loading state and mask visibility in a state tree
     * @param value
     */
    handleLoaderAndMask(value: boolean) {
        this.setState({
            ...this.state,
            loading: value,
            activeMask: value,
        })
    }

    /**
     * Changes visiiblity of mask via
     * activeMask state
     * @param value
     */
    handleMask(value) {
        this.setState({
            ...this.state,
            activeMask: value,
        })
    }
    handleUpload(data) {
        this.setState({
            ...this.state,
            loading: false,
            path: `/${data.previews[this.state.filter].path}?${Date.now()}`,
            cropPath: `/${data.previews['widden_crop'].path}?${Date.now()}`,
            reference: data.ref,
            hovered: false,
        });
        this.props.onUpload(data);
    }

    handleSaveNewCropSettings(values) {
        console.log(values);
        this.setState({
            ...this.state,
            cropValues: values,
        });
    }
    handleCrop(data, cropValues) {
        console.log(data);
        console.log(cropValues);
        this.setState({
            ...this.state,
            cropping: false,
            path: `/${data.previews[this.state.filter].path}`,
            cropValues: cropValues,
            reference: data.ref,
            hovered: false,
        });

        if (this.props.onCrop !== undefined) {
            this.props.onCrop(data);
        }
    }

    handleCropPopup(values) {
        if (!this.state.fetchedCropData) {
            this.setState({
                ...this.state,
                fetchedCropData: true,
            });
        }
        this.setState({
            ...this.state,
            cropping: true,
        });
    }
    handleCropCancel() {
        this.setState({
            ...this.state,
            cropping: false,
        })
    }
    handleDelete() {
        this.setState({
            ...this.state,
            path: null,
            reference: null,
        });
        if (this.props.onDelete !== undefined) {
            this.props.onDelete();
        }
    }
    renderCropPopup() {
        if (this.state.cropping && this.state.path !== null) {
            return (
                <CropPopup
                    src={this.state.cropPath}
                    cropValues={this.state.cropValues}
                    filter={this.state.filter}
                    reference={this.state.reference}
                    uploaded={this.state.uploaded}
                    onChange={::this.handleCropPopup}
                    onCancel={::this.handleCropCancel}
                    onCrop={(data, cropValues)=>this.handleCrop(data, cropValues)}
                />
            )
        }
    }
    renderBackground() {
        const { mediaType } = this.props;
        const { path } = this.state;

        if (path !== null && mediaType !== null) {
            const backgroundClasses = classNames({
                'media-uploader__background': true,
                'hovered': this.state.hovered,
            })

            return (
                <div className={backgroundClasses} style={{ backgroundImage: `url(${path})` }}>
                    <div className="background__dark-mask" />
                </div>
            )
        }
    }

    render() {
        const { loading, cropping, activeMask, reference, uploaderType, fetchedCropData, path } = this.state;
        const mediaUploaderClasses = classNames({
            'media-uploader__elements': true,
            'avatar': this.props.uploaderType === 'avatar',
        });
        return (
            <div className={mediaUploaderClasses}
                onMouseOver={() => {
                    if (!this.state.cropping) {
                        this.setState({
                            ...this.state,
                            hovered: true,
                        });
                    }
                }}
                onMouseLeave={() => {
                    if (!this.state.cropping) {
                        this.setState({
                            ...this.state,
                            hovered: false,
                        });
                    }
                }}
            >
                {::this.renderBackground()}
                {::this.renderCropPopup()}
                <div className="media-uploader">
                    <div className="media-uploader--container">
                        <UploaderBackground path={this.state.path} loading={this.state.loading} />
                        <UploaderMask
                            activeMask={activeMask}
                            cropping={cropping}
                            loading={loading}
                            reference={reference}
                            uploaderType={uploaderType}
                            fetchedCropData={fetchedCropData}
                            path={path}

                            hash={this.props.hash}
                            id={this.props.id}
                            filter={this.props.filter}

                            handleCropPopup={::this.handleCropPopup}
                            handleLoader={::this.handleLoader}

                            onSaveNewCropSettings={::this.handleSaveNewCropSettings}
                            handleLoaderAndMask={::this.handleLoaderAndMask}
                            onUpload={::this.handleUpload}
                            onDelete={::this.handleDelete}
                            handleMask={::this.handleMask}
                        />
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/MediaUploader.jsx